import { Component } from "@angular/core";

@Component({
  standalone: false,
  selector: "analise",
  templateUrl: "./analise.component.html"
})
export class AnaliseComponent {

  constructor() { }

}